import { WordPressSources } from "../consts";
// Home page news section
export async function fetchNewsUpdate() {
    const response = await fetch(WordPressSources.newsUpdates);
    const json = await response.json();
    let parsedData = [];
    json.forEach(item => {
        parsedData.push({
            id: item.id,
            title: (typeof item.title === "object") ? item.title.rendered : item.id,
            description: (typeof item.title === "object") ? item.content.rendered : item.id
        });
    });
    return parsedData;
}
